import React, { FC } from 'react';

import { useModals } from '@contexts/common/ModalContext';

import BondsDisclaimerModal from '@modules/modals/bonds/BondsDisclaimerModal';
import RedeemModal from '@modules/modals/bonds/RedeemModal';
import StakeBondsModal from '@modules/modals/bonds/StakeBondsModal';
import UnstakeBondsModal from '@modules/modals/bonds/UnstakeBondsModal';
import WrongNetworkModal from '@modules/modals/common/WrongNetworkModal';

import { MODAL_TYPES } from '@constants/common/modals.constants';

const Modals: FC = () => {
  const { state } = useModals();

  return (
    <>
      {state.current === MODAL_TYPES.WRONG_NETWORK_MODAL && (
        <WrongNetworkModal />
      )}
      {state.current === MODAL_TYPES.BONDS_REDEEM_MODAL && <RedeemModal />}
      {state.current === MODAL_TYPES.BONDS_STAKE_MODAL && <StakeBondsModal />}
      {state.current === MODAL_TYPES.BONDS_UNSTAKE_MODAL && (
        <UnstakeBondsModal />
      )}
      {state.current === MODAL_TYPES.BONDS_DISCLAIMER_MODAL && (
        <BondsDisclaimerModal />
      )}
    </>
  );
};

export default Modals;
